import { client } from "../../../../ajax";
import {
  sendingRequest,
  receivedResponse,
  createAction
} from "../../../../redux_util";
import formatError from "../../../../formatErrors";

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";

export const changePasswordSuccess = createAction(
  CHANGE_PASSWORD_SUCCESS,
  "message"
);
export const changePassword = data => {
  return dispatch => {
    dispatch(sendingRequest("changePassword"));
    return client
      .post(`changepassword`, data)
      .then(res => {
        dispatch(receivedResponse("changePassword"));
        return dispatch(changePasswordSuccess("Login Successful"));
      })
      .catch(err => {
        return dispatch(receivedResponse("changePassword", formatError(err)));
      });
  };
};



// WEBPACK FOOTER //
// ./src/components/screens/ChangePassword/redux/actions.js